/**
 * Global loader: six accent-colour dots (like Home hero) with staggered animation.
 * Use for auth check, route resolution, or any full-context loading state.
 */
const DOT_COLORS = [
  'bg-africa-red',
  'bg-africa-orange',
  'bg-africa-yellow',
  'bg-africa-green',
  'bg-africa-blue',
  'bg-africa-purple',
] as const;

export function GlobalLoader({ className }: { className?: string }) {
  return (
    <div className={`flex items-center justify-center gap-2 ${className ?? ''}`} role="status" aria-label="Loading">
      {DOT_COLORS.map((color, i) => (
        <span
          key={color}
          className={`w-3 h-3 rounded-full ${color} animate-loader-dot`}
          style={{ animationDelay: `${i * 0.12}s` }}
        />
      ))}
    </div>
  );
}

/** Full-page centered global loader (e.g. for ProtectedRoute or initial auth) */
export function GlobalLoaderPage() {
  return (
    <div className="min-h-[75vh] flex flex-col items-center justify-center px-6">
      <GlobalLoader className="mb-4" />
      <p className="text-sm text-muted-foreground">Loading…</p>
    </div>
  );
}
